export const platforms = {
  android: {
    name: "Android",
    status: "available",
    appName: "CyberX Calls",
    packageName: "com.cyberxcalls.softphone",
    version: "1.0.2",
    versionCode: 3,
    releaseDate: "25 August 2026",
    minimumAndroid: "Android 8.0 or later",
    sipServer: "sip.cyberxcalls.com",
    builds: [
      {
        name: "ARM64",
        architecture: "arm64-v8a",
        description: "Recommended for almost every modern Android phone and tablet.",
        size: "47.7 MiB",
        bytes: 50061467,
        filename: "CyberX-Calls-v1.0.2-arm64-v8a.apk",
        sha256: "81e1f6f385a5822a0646acabdeb08903037ec7f609f8f536c5b7a2c611bb0e06",
        recommended: true,
      },
      {
        name: "ARM 32-bit",
        architecture: "armeabi-v7a",
        description: "For older 32-bit Android phones and tablets.",
        size: "38.4 MiB",
        bytes: 40288739,
        filename: "CyberX-Calls-v1.0.2-armeabi-v7a.apk",
        sha256: "bfa8883910e4a3ea0faf1fe341ce4fda0274b9cfe63faf48cc758b29790c3510",
      },
      {
        name: "Intel 64-bit",
        architecture: "x86_64",
        description: "For 64-bit Intel Android emulators and specialist devices.",
        size: "49.7 MiB",
        bytes: 52125089,
        filename: "CyberX-Calls-v1.0.2-x86_64.apk",
        sha256: "67ac0f2bdde826998379b449f71a4107b816d1eea4b77a638e798230c8746d18",
      },
      {
        name: "Intel 32-bit",
        architecture: "x86",
        description: "For older 32-bit Intel emulators and Android devices.",
        size: "46.6 MiB",
        bytes: 48898767,
        filename: "CyberX-Calls-v1.0.2-x86.apk",
        sha256: "3ce7985a7eea75b98943d62af222ea4b7153abf83473508d45d59e514b6e7f2d",
      },
    ],
    changes: [
      "Added separate, smaller APK downloads for ARM64, ARM 32-bit, x86 and x86_64 devices.",
      "Improved the CyberX Server diagnostic for restrictive mobile and Wi-Fi networks.",
      "Added a TCP port 5060 fallback check when UDP port 5060 does not respond.",
      "Improved messages that distinguish credential errors from network or SIP-port failures.",
      "Removed resolved server IP addresses from the diagnostic display.",
      "Added clearer guidance for possible firewall, NAT, Fail2ban or network-port blocking.",
      "Added a temporary trusted-VPN suggestion for blocked SIP networks, subject to local law and network policy.",
      "Retained calling, contacts, DTMF, history, multi-account and audio-device features from version 1.0.1.",
    ],
  },
  windows: {
    name: "Windows",
    status: "coming-soon",
    description: "A native CyberX Calls desktop softphone is currently under development.",
  },
  macos: {
    name: "macOS",
    status: "coming-soon",
    description: "A CyberX Calls desktop softphone for Mac is coming soon.",
  },
};

export const versionHistory = [
  {
    version: "1.0.1",
    changes: [
      "Introduced the production-signed CyberX Calls Android release.",
      "Added secure multi-account storage, quick account switching and account deletion.",
      "Added remote DTMF capture with timestamps, duplicate filtering, copy, clear and privacy controls.",
      "Added detailed call states, registration feedback and failed-call error codes.",
      "Added contacts, local call history, one-tap redial and audio-device controls.",
      "Added background SIP registration and start-on-boot defaults.",
    ],
  },
];
